<mat-card>
  <mat-card-header>
    <mat-card-title *ngIf="!isSignedIn">Please Sign In</mat-card-title>
    <mat-card-title *ngIf="isSignedIn">Dashboard</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p *ngIf="isSignedIn && workspaces != 1">You are in {{ workspaces }} workspaces</p>
    <p *ngIf="isSignedIn && workspaces == 1">You are in {{ workspaces }} workspace</p>
  </mat-card-content>
</mat-card>